import { render, staticRenderFns } from "./JokesComponent.vue?vue&type=template&id=8daa07bc&"
import script from "./JokesComponent.vue?vue&type=script&lang=js&"
export * from "./JokesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports